module.exports = __webpack_public_path__ + "img/抠鼻.53124140.gif";